export class ConfirmationResponse {
    ok: boolean;
    comment: string;
}
